import { createFileRoute } from '@tanstack/react-router';
import { safeguardsQuery } from '../../api/evidence.ts';
import { SafeguardsPage } from '../../features/evidence/safeguards-page.tsx';
import {
  filtersOf,
  validateSafeguardSearch,
  type SafeguardSearch,
} from '../../features/evidence/search.ts';

// Safeguards register (T26). Filters are search params: every change is a new history entry, so
// Back returns to the previous filters (constitution §5.6).
export const Route = createFileRoute('/_authed/evidence/')({
  validateSearch: validateSafeguardSearch,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => {
    void context.queryClient.prefetchQuery(safeguardsQuery(filtersOf(deps)));
  },
  component: SafeguardsRoute,
});

function SafeguardsRoute(): React.JSX.Element {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  // The patch holds raw form values; the same check as the URL turns them into filters.
  const onSearch = (next: SafeguardSearch): void => {
    void navigate({ search: () => validateSafeguardSearch({ ...next }) });
  };
  return <SafeguardsPage search={search} onSearch={onSearch} />;
}
